/**
 * Wrapper for dataTestid.
 */
export const injDataTest = (name: string | string[]) => ({
  'data-testid': Array.isArray(name) ? name.join('-') : name,
  dataTest: Array.isArray(name) ? name.join('-') : name,
});
